import { render } from "./MargeAchat.vue?vue&type=template&id=61f6efda&scoped=true"
import script from "./MargeAchat.vue?vue&type=script&lang=js"
export * from "./MargeAchat.vue?vue&type=script&lang=js"

import "./MargeAchat.vue?vue&type=style&index=0&id=61f6efda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f6efda"]])

export default __exports__